import { createSlice } from "@reduxjs/toolkit";
import { acceptEnrollmentAPI } from "../../../services/guestUsers/guestUserAllAPIService";
const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const acceptEnrollmentSlice = createSlice({
  name: "acceptEnrollment",
  initialState: data,
  reducers: {
    acceptEnrollmentSliceInfo(state) {
      state.isLoading = true;
    },
    acceptEnrollmentSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    acceptEnrollmentSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    acceptEnrollmentSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const acceptEnrollmentHandler = (data) => async (dispatch) => {
  try {
    dispatch(acceptEnrollmentSliceAction.acceptEnrollmentSliceInfo());
    const response = await acceptEnrollmentAPI(data);
    dispatch(
      acceptEnrollmentSliceAction.acceptEnrollmentSliceSuccess(response),
    );
  } catch (e) {
    dispatch(acceptEnrollmentSliceAction.acceptEnrollmentSliceFailure(e));
  }
};
export default acceptEnrollmentSlice.reducer;
export const acceptEnrollmentSliceAction = acceptEnrollmentSlice.actions;
